<template>
  <div class="el-col-24">
    <h5 class="warp-title">评价设置</h5>
    <div class="search">
      <el-form :inline="true" size="small">
        <el-form-item label="评价问题">
          <el-input placeholder="请输入问题关键字" v-model="searchForm.evaluateProblem"></el-input>
        </el-form-item>
        <el-form-item label="状态">
           <el-select v-model="searchForm.status" placeholder="请选择状态">
            <el-option label="全部" :value="-1"></el-option>
            <el-option label="上架" :value="0"></el-option>
            <el-option label="下架" :value="1"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" size="small" @click="queryEvaluateSetPage" :loading="isSearchLoading">查询</el-button>
          <el-button size="small" @click="clearOption">清空选项</el-button>
        </el-form-item>
      </el-form>
    </div>
    <el-button type="primary" class="add-btn" size="small" @click="toAdd">新增</el-button>
    <el-table :data="tableData" border style="width: 100%">
      <el-table-column label="序号" width="180">
        <template slot-scope="scope">
          <span>{{searchForm.pageSize * (searchForm.currentPage-1) + scope.$index+1}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="evaluateProblem" label="评价问题"></el-table-column>
      <el-table-column prop="createUserName" label="添加人" width="180"></el-table-column>
      <el-table-column prop="status" label="状态" width="180">
        <template slot-scope="scope">
          <span v-if="scope.row.status === 0">上架</span>
          <span v-if="scope.row.status === 1">下架</span>
        </template>
      </el-table-column>
      <el-table-column label="操作">
        <template slot-scope="scope">
          <el-link type="primary" :underline="false" v-if="scope.row.status === 1" @click="toSet(scope.row)">上架</el-link>
          <el-link type="primary" :underline="false" v-if="scope.row.status === 0" @click="toSet(scope.row)">下架</el-link>
          <el-link type="primary" :underline="false" @click="toEdit(scope.row.id)">编辑</el-link>
          <!-- <el-link type="danger" :underline="false">删除</el-link> -->
          <!-- <el-link type="primary" :underline="false">查看</el-link> -->
        </template>
      </el-table-column>
    </el-table>
    <el-pagination class="mt20" align="right" @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="searchForm.currentPage" :page-sizes="[10, 20, 30, 40]" :page-size="searchForm.pageSize" layout="total, sizes, prev, pager, next, jumper" :total="total" background>
    </el-pagination>
    <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" width="30%" :show-close="false" class="dialog">
      <div class="content">
        <el-form :rules="rules" ref="form" :model="addForm">
          <el-form-item prop="evaluateProblem" label="评价问题标语：">
            <el-input v-model="addForm.evaluateProblem" placeholder="请输入内容"></el-input>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="submit" :loading="isAddLoading">提 交</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {addEvaluateSet, queryEvaluateSetPage, editReturnEvaluateSet, editEvaluateSet, deleteEvaluateSet} from '@/api/appraiseManage/index.js'
export default {
  name: 'AppraiseSet',
  created () {
    // this.queryEvaluateSetPage()
  },
  data () {
    return {
      isAddLoading: false,
      isSearchLoading: false,
      searchForm: {
        evaluateProblem: '',
        status: -1,
        currentPage: 1,
        pageSize: 10
      },
      addForm: {
        evaluateProblem: ''
      },
      dialogVisible: false,
      total: 0,
      tableData: [],
      rules: {
        evaluateProblem: [
          {required: true, message: '请输入问题标语', trigger: 'blur'}
        ]
      },
      dialogTitle: '评价问题新增'
    }
  },
  watch: {
    dialogVisible (newVal) {
      if (!newVal) {
        this.$refs.form.resetFields()
        this.dialogTitle = '评价问题新增'
      }
    }
  },
  methods: {
    // 页容量变化
    handleSizeChange (size) {
      this.searchForm.pageSize = size
      this.searchForm.currentPage = 1
      this.queryEvaluateSetPage()
    },
    // 当前页变化
    handleCurrentChange (current) {
      this.searchForm.currentPage = current
      this.queryEvaluateSetPage()
    },
    // 清空筛选条件
    clearOption () {
      this.searchForm = {
        evaluateProblem: '',
        status: -1,
        currentPage: 1,
        pageSize: 10
      }
      this.queryEvaluateSetPage()
    },
    // 打开新增窗口
    toAdd () {
      this.dialogVisible = true
    },
    // 提交新增/编辑
    submit () {
      this.$refs.form.validate(res => {
        if (res) {
          this.isAddLoading = true
          if (this.dialogTitle === '评价问题新增') {
            addEvaluateSet(this.addForm).then(res => {
              this.isAddLoading = false
              if (res.data.resultCode === 0) {
                this.$message({
                  message: '新增成功',
                  type: 'success'
                })
                this.dialogVisible = false
                this.searchForm.currentPage = 1
                this.queryEvaluateSetPage()
              }
            }).catch(() => {
              this.isAddLoading = false
            })
          } else {
            editEvaluateSet(this.addForm).then(res => {
              this.isAddLoading = false
              if (res.data.resultCode === 0) {
                this.$message({
                  message: '编辑成功',
                  type: 'success'
                })
                this.dialogVisible = false
                this.searchForm.currentPage = 1
                this.queryEvaluateSetPage()
              }
            }).catch(() => {
              this.isAddLoading = false
            })
          }
        }
      })
    },
    // 打开编辑窗口
    toEdit (id) {
      this.dialogTitle = '评价问题编辑'
      this.dialogVisible = true
      editReturnEvaluateSet({id: id}).then(res => {
        this.addForm.evaluateProblem = res.data.resultData.evaluateProblem
        this.addForm.id = res.data.resultData.id
      })
    },
    // 获取评价设置列表
    queryEvaluateSetPage () {
      this.isSearchLoading = true
      queryEvaluateSetPage(this.searchForm).then(res => {
        this.isSearchLoading = false
        this.tableData = res.data.resultData
        this.total = res.data.totalCount
      }).catch(() => {
        this.isSearchLoading = false
      })
    },
    // 上下架设置
    toSet (row) {
      deleteEvaluateSet(row).then(res => {
        if (res.data.resultCode === 0) {
          const setTitle = row.status === 1 ? '上架成功' : '下架成功'
          this.dialogVisible = false
          this.$message({
            message: setTitle,
            type: 'success'
          })
          this.searchForm.currentPage = 1
          this.queryEvaluateSetPage()
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
.add-btn{
  float: right;
  margin-bottom: 10px;
}
/deep/.el-table .cell{
  text-align: center;
}
/deep/.el-dialog__header{
  text-align: center;
  font-weight: 700;
}
</style>



// WEBPACK FOOTER //
// src/components/AppraiseManage/AppraiseSet.vue